import { defineStore } from "pinia";
import Services from '@/services/contactServices'
import { mapContact } from '@/helpers/mapFuncs'

export const useContactStore = defineStore("contact", {

state:()=>({
    contact: {},
    contacts: [],
}),
getters : {
    getContact() {
        return mapContact(this.contact)
    },
    getContacts() {
        return this.contacts.map(mapContact)
    }
},
actions : {
    /** Start Sets */
    setContact(contact) {
        this.contact = contact
    },
    setContacts(contacts) {
        this.contacts = contacts
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setContact(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setContacts(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setContacts(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.contacts.push(response.data.data)
            return mapContact(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.contacts[this.contacts.findIndex((x)=>x.id == id)] = response.data.data
            return mapContact(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.contacts = this.contacts.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});